exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".SequenceBuilder {\n  height: 424px;\n  max-height: 430px;\n}\n", ""]);

// exports
